export const BETA_ROOT_PATH = '/beta';

const EXTERNAL_PATTERN = /^(https?:|mailto:|tel:|#)/i;

export const isExternalPath = (path) => EXTERNAL_PATTERN.test(path);

export const extractBetaProgramSlug = (pathname = '') => {
  const match = pathname.match(/^\/beta\/([^/]+)(?:\/|$)/);
  return match ? match[1] : null;
};

export const stripBetaPrefix = (pathname = '/') => {
  const slug = extractBetaProgramSlug(pathname);

  if (!slug) {
    return pathname;
  }

  const prefix = `/beta/${slug}`;
  const stripped = pathname.slice(prefix.length);
  return stripped || '/';
};

export const buildBetaProgramPath = (programSlug, sitePath = '/') => {
  const normalizedPath = sitePath.startsWith('/') ? sitePath : `/${sitePath}`;

  if (!programSlug) {
    return normalizedPath;
  }

  if (normalizedPath === '/') {
    return `/beta/${programSlug}`;
  }

  return `/beta/${programSlug}${normalizedPath}`;
};

export const toProgramAwarePath = (to, currentPathname = '/') => {
  if (typeof to !== 'string' || to.length === 0 || isExternalPath(to)) {
    return to;
  }

  if (to.startsWith(BETA_ROOT_PATH)) {
    return to;
  }

  const programSlug = extractBetaProgramSlug(currentPathname);

  if (!programSlug) {
    return to;
  }

  return buildBetaProgramPath(programSlug, to);
};
